import { schema as inviteUserSchema } from "../../../../../../schemas/inviteUser";

export const INVITATION_CSV_HEADERS = ["first_name", "last_name", "email"];

export function normalizeInvitationCsvRow(row = {}) {
  return {
    first_name: `${row?.first_name || ""}`.trim(),
    last_name: `${row?.last_name || ""}`.trim(),
    email: `${row?.email || ""}`.trim(),
  };
}

export function validateInvitationCsvHeaders(headers = []) {
  if (!headers.length) {
    return "CSV file is empty or missing headers.";
  }

  if (headers.join(",") !== INVITATION_CSV_HEADERS.join(",")) {
    return "CSV header does not match expected format.";
  }

  const missingColumns = INVITATION_CSV_HEADERS.filter(
    (column) => !headers.includes(column)
  );

  if (missingColumns.length > 0) {
    return `Missing columns: ${missingColumns.join(", ")}`;
  }

  return "";
}

export function validateInvitationCsvRows(rows = []) {
  let isValid = true;

  const validatedRows = rows.map((row, index) => {
    const normalizedRow = normalizeInvitationCsvRow(row);
    const errors = {};

    try {
      inviteUserSchema.validateSync(normalizedRow, { abortEarly: false });
    } catch (error) {
      isValid = false;

      error.inner.forEach((item) => {
        if (item.path && !errors[item.path]) {
          errors[item.path] = item.message;
        }
      });
    }

    return {
      id: index + 1,
      ...normalizedRow,
      errors,
      isValid: Object.keys(errors).length === 0,
    };
  });

  return {
    rows: validatedRows,
    isValid,
  };
}
